const basket = localStorage.getItem('induline-store');

/**
 * Current fixes:
 * - Remove products from localstorage basket that have no content prop on variants (Required after change in 05/2022)
 */

if (basket && basket !== '') {
    let basketJSON = JSON.parse(basket);

    if (basketJSON && basketJSON.store && basketJSON.store.basket && basketJSON.store.basket.products && basketJSON.store.basket.products.length) {
        let products = basketJSON.store.basket.products;
        let indexesToDelete = [];

        for (let index = 0; index < products.length; index++) {
            const product = products[index];

            if (product) {
                if (!product.variant || (product.variant && product.variant && !product.variant.content)) {
                    // delete when no variant or variant has no "content" prop
                    indexesToDelete.push(index);
                }

                if (product.productData && product.productData.variants && product.productData.variants.length) {
                    product.productData.variants.forEach(variant => {
                        if (!variant.content) {
                            // delete when variant has no "content" prop
                            indexesToDelete.push(index);
                        }
                    });
                }
            }
        }

        if (indexesToDelete.length) {
            // remove the products from localstorage for which we have found critical errors
            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }

            const uniqueIndexesToDelete = indexesToDelete.filter(onlyUnique);

            basketJSON.store.basket.products = basketJSON.store.basket.products.filter((value, index) => !uniqueIndexesToDelete.includes(index));

            localStorage.setItem('induline-store', JSON.stringify(basketJSON));

            location.reload();
        }
    }
}
